import { Outlet, useLocation } from 'react-router-dom'
import { AnimatePresence } from 'motion/react'
import { Header } from '@/components/Header'
import { Footer } from '@/components/Footer'
import { Breadcrumbs, generateBreadcrumbs, breadcrumbLabels } from '@/components/Breadcrumbs'
import { PageTransition } from '@/components/PageTransition'
import { useLenis } from '@gjl/motion/gsap'
import { usePageEngagement } from '@/hooks/usePageEngagement'
import { useReturnVisitTracker } from '@/hooks/useReturnVisitTracker'

export default function MainLayout() {
  // Initialize smooth scrolling
  useLenis()
  // GA4 engagement tracking
  usePageEngagement()
  useReturnVisitTracker()
  const location = useLocation()
  const isHomePage = location.pathname === '/'

  // Generate breadcrumbs from current path
  const breadcrumbItems = generateBreadcrumbs(location.pathname, breadcrumbLabels)

  return (
    <div className="flex min-h-screen flex-col">
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-[100] focus:rounded focus:bg-white focus:px-4 focus:py-2 focus:text-black focus:shadow"
      >
        Skip to content
      </a>
      <Header />
      <main id="main-content" className="flex-grow">
        {/* Show breadcrumbs on all pages except homepage */}
        {!isHomePage && breadcrumbItems.length > 0 && (
          <div className="container mx-auto px-4 pt-4">
            <Breadcrumbs items={breadcrumbItems} />
          </div>
        )}
        <AnimatePresence mode="wait">
          <PageTransition key={location.pathname}>
            <Outlet />
          </PageTransition>
        </AnimatePresence>
      </main>
      <Footer />
    </div>
  )
}
